import { NgModule } from '@angular/core';
import { SharedModule } from '~app/app/~shared/modules/shared.module';
import { BrandListListDatatableComponent } from './components/brand-list-datatable/brand-list-datatable.component';
import { BrandDetailsComponent } from './components/brand-details/brand-details.component';

const DECLARATIONS = [BrandListListDatatableComponent, BrandDetailsComponent];

const MODULES = [SharedModule];

@NgModule({
  declarations: DECLARATIONS,
  imports: [...MODULES],
  exports: [...MODULES, ...DECLARATIONS],
  providers: []
})
export class BrandModule {}
